import VideoInstruction from '@/components/video-instruction/video-instruction';

export default VideoInstruction;
